import { Button, Group, Modal, Text } from '@mantine/core';
import { ReactNode } from 'react';

interface ConfirmModalProps {
  opened: boolean;
  title: string;
  children: ReactNode;
  confirmLabel: string;
  loading?: boolean;
  color?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

/** Last chance before an operation that cannot be undone from the screen. */
export function ConfirmModal({
  opened,
  title,
  children,
  confirmLabel,
  loading,
  color,
  onConfirm,
  onCancel,
}: ConfirmModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onCancel}
      title={title}
      size="sm"
      closeOnClickOutside={false}
      zIndex={400}
    >
      {typeof children === 'string' ? <Text>{children}</Text> : children}
      <Group position="right" mt="lg">
        <Button variant="default" onClick={onCancel} disabled={loading}>
          Cancelar
        </Button>
        <Button color={color} onClick={onConfirm} loading={loading}>
          {confirmLabel}
        </Button>
      </Group>
    </Modal>
  );
}
